<mat-card class="example-card">
  <mat-card-header>
    <div mat-card-avatar class="example-header-image">
      
    </div>
    <mat-card-title>{{member.nickName}}</mat-card-title>
    <mat-card-subtitle>{{member.city}}</mat-card-subtitle>
    <mat-chip-list aria-label="Fish selection">
    
      <mat-chip color="accent" selected>{{member.age}}</mat-chip>
    </mat-chip-list>
    <!-- <span>Age: {{member.age}}</span> -->
  </mat-card-header>
  
  <img mat-card-image src="{{member.photoUrl || '/assets/ugo.jpg'}}" alt="{{member.nickName}}">
  <mat-card-content>
    <p>
      {{member.introduction?.substring(0,50)}}...
    </p>
  </mat-card-content>
  <mat-card-actions>
    <button style="outline: none;" 
    [class.is-online]="(presence.onlineUsers$ | async)?.includes(member.userName)" 
    routerLink='/members/{{member.userName}}' 
    mat-icon-button mat-icon-button><mat-icon>person</mat-icon></button>

    <button (click)="addLike(member)" [color]='member.liked ? "primary" : "accent"' style="outline: none;" mat-icon-button><mat-icon>favorite</mat-icon></button>

    <button style="outline: none;" mat-icon-button routerLink='/members/{{member.userName}}' [queryParams]='{tab: 3}'> 
      <mat-icon>message</mat-icon>
    </button>
  </mat-card-actions>
</mat-card>